/**
 * SPDX-FileCopyrightText: (c) 2026 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import ClayButton from '@clayui/button';
import classNames from 'classnames';
import React from 'react';

function Action({
	children,
	className,
	...otherProps
}: React.HTMLAttributes<HTMLButtonElement>) {
	return (
		<div className={classNames('dropdown-section', className)}>
			<ClayButton block {...otherProps}>
				{children}
			</ClayButton>
		</div>
	);
}

export default Action;
